<main class="main-home-secton">
    <div class="">
        <div class="container">
            <div class="div-header">
                <h1>Privacy Policy</h1>
            </div>

        </div>
    </div>
    <div class="event-main">
        <div class="container">
            <mat-accordion>
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header >
                        <mat-panel-title>
                            SECTION 1 – WHAT DO WE DO WITH YOUR INFORMATION?
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="tab-datas">
                        <p>When you signup with the StartupTN.in portal, as part of the buying and selling process,
                            we collect the personal information you give us such as your name, address, and email
                            address.</p>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            SECTION 2 – CONSENT
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="tab-datas">
                        <h5><b>How do you get my consent?</b></h5>
                        <p>When you provide us with personal information to complete registration, verify your mobile
                            number, claim a deal, we imply that you consent to our collecting it and using it for that
                            specific reason only.</p>
                        <p>If we ask for your personal information for a secondary reason, like marketing, we will
                            either ask you directly for your expressed consent or provide you with an opportunity to say
                            no.</p>
                        <h5><b>How do I withdraw my consent?</b></h5>
                        <p>If after you opt-in, you change your mind, you may withdraw your consent for us to contact
                            you, for the continued collection, use or disclosure of your information, at any time, by
                            contacting us at support@startuptn.in</p>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            SECTION 3 – DISCLOSURE
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="tab-datas">
                        <p>We may disclose your personal information if we are required by law to do so or if you
                            violate our Terms of Service.</p>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            SECTION 4 – PAYMENT
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="tab-datas">
                        <p>We use 3rd party approved vendors for processing payments. We do not store your card data on
                            their servers. The data is encrypted through the Payment Card Industry Data Security
                            Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as
                            long as is necessary to complete your purchase transaction. After that is complete, your
                            purchase transaction information is not saved.</p>
                        <p>Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security
                            Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express
                            and Discover.</p>
                        <p>PCI-DSS requirements help ensure the secure handling of credit card information by
                            StartupTN.in portal and its service providers.</p>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            SECTION 5 – THIRD-PARTY SERVICES
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="tab-datas">
                        <p>In general, the third-party providers used by us will only collect, use and disclose your
                            information to the extent necessary to allow them to perform the services they provide to
                            us.</p>
                        <p>However, certain third-party service providers, such as payment gateways and other payment
                            transaction processors, have their own privacy policies in respect to the information we are
                            required to provide to them for your purchase-related transactions.</p>
                        <p>For these providers, we recommend that you read their privacy policies so you can understand
                            the manner in which your personal information will be handled by these providers.</p>
                        <p>In particular, remember that certain providers may be located in or have facilities that are
                            located a different jurisdiction than either you or us. So if you elect to proceed with a
                            transaction that involves the services of a third-party service provider, then your
                            information may become subject to the laws of the jurisdiction(s) in which that service
                            provider or its facilities are located.</p>
                        <p>Once you leave StartupTN.in portal or are redirected to a third-party website or application,
                            you are no longer governed by this Privacy Policy or our website’s Terms of Service.</p>
                        <h5><b>Links</b></h5>
                        <p>When you click on links on StartupTN.in portal, they may direct you away from our site. We
                            are not responsible for the privacy practices of other sites and encourage you to read their
                            privacy statements.</p>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            SECTION 6 – SECURITY
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="tab-datas">
                        <p>To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.</p>
                        
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            SECTION 7 – COOKIES
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="tab-datas">
                        <p>We use cookies to maintain session of your user. It is not used to personally identify you on other websites.</p>
                        
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            SECTION 8 – AGE OF CONSENT
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="tab-datas">
                        <p>By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.</p>
                        
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            SECTION 9 – CHANGES TO THIS PRIVACY POLICY
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="tab-datas">
                        <p>We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.</p>
                        
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <div class="mt-5">
                <h5>QUESTIONS AND CONTACT INFORMATION</h5>
                <p>If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at <a href="mailto: support@startuptn.in">support@startuptn.in</a> </p>
            </div>
            <div class="mt-4">
                <p class="mb-0">Manager, TAMILNADU STARTUP AND INNOVATION MISSION</p>
                <p class="mb-0">D3-10, 3rd FLOOR, IIT MADRAS RESEARCH PARK</p>
                <p class="mb-0">KANAGAM ROAD, TARAMANI</p>
                <p class="mb-0">CHENNAI</p>
                <p class="mb-0">Chennai – 600113</p>
                <p class="mb-0">Tamil Nadu – India</p>
            </div>
        </div>
    </div>
</main>
<app-footer></app-footer>